import script from "./ChoiceButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChoiceButton.vue?vue&type=script&setup=true&lang=ts"

import "./ChoiceButton.vue?vue&type=style&index=0&id=d6ca5156&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6ca5156"]])

export default __exports__